export const UPDATE_GAME_CONFIGURATION = "UPDATE_GAME_CONFIGURATION";
export const RESET = "RESET";
export const SET_CODE = "SET_CODE";
export const SELECT_GAME = "SELECT_GAME";
export const UPDATE_GAME_LIST = "UPDATE_GAME_LIST";
export const SBC_STATUS_CHANGED = "SBC_STATUS_CHANGED";
